import { CalendarDate } from '@internationalized/date';
import { toISODateString } from '@rematter/common/dateTime';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const bookingMarkAsShippedAtom = createMutationAtomFactory(
  'trade.bookingMarkAsShipped',
  (params: { id: string; shippedDate?: CalendarDate }) => ({
    tradeBookingShip: {
      __args: {
        input: {
          id: params.id,
          shippedDate: params.shippedDate
            ? toISODateString(params.shippedDate)
            : undefined,
        },
      },
      id: true,
    },
  }),
);
